/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MstUserOutput } from './MstUserOutput';
import {
    MstUserOutputFromJSON,
    MstUserOutputFromJSONTyped,
    MstUserOutputToJSON,
    MstUserOutputToJSONTyped,
} from './MstUserOutput';
import type { ResponseUpdateError } from './ResponseUpdateError';
import {
    ResponseUpdateErrorFromJSON,
    ResponseUpdateErrorFromJSONTyped,
    ResponseUpdateErrorToJSON,
    ResponseUpdateErrorToJSONTyped,
} from './ResponseUpdateError';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 * 
 * @export
 * @interface ResponseUserUpdate
 */
export interface ResponseUserUpdate {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseUserUpdate
     */
    result: ResponseResult;
    /**
     * 
     * @type {Array<ResponseUpdateError>}
     * @memberof ResponseUserUpdate
     */
    errors: Array<ResponseUpdateError> | null;
    /**
     * 
     * @type {number}
     * @memberof ResponseUserUpdate
     */
    updateCount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof ResponseUserUpdate
     */
    lastUpdateDatetime: Date | null;
    /**
     * 
     * @type {MstUserOutput}
     * @memberof ResponseUserUpdate
     */
    data: MstUserOutput | null;
}

/**
 * Check if a given object implements the ResponseUserUpdate interface.
 */
export function instanceOfResponseUserUpdate(value: object): value is ResponseUserUpdate {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('errors' in value) || value['errors'] === undefined) return false;
    if (!('updateCount' in value) || value['updateCount'] === undefined) return false;
    if (!('lastUpdateDatetime' in value) || value['lastUpdateDatetime'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseUserUpdateFromJSON(json: any): ResponseUserUpdate {
    return ResponseUserUpdateFromJSONTyped(json, false);
}

export function ResponseUserUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseUserUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'errors': (json['errors'] == null ? null : (json['errors'] as Array<any>).map(ResponseUpdateErrorFromJSON)),
        'updateCount': json['update_count'],
        'lastUpdateDatetime': (json['last_update_datetime'] == null ? null : new Date(json['last_update_datetime'])),
        'data': MstUserOutputFromJSON(json['data']),
    };
}

export function ResponseUserUpdateToJSON(json: any): ResponseUserUpdate {
    return ResponseUserUpdateToJSONTyped(json, false);
}

export function ResponseUserUpdateToJSONTyped(value?: ResponseUserUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'errors': (value['errors'] == null ? null : (value['errors'] as Array<any>).map(ResponseUpdateErrorToJSON)),
        'update_count': value['updateCount'],
        'last_update_datetime': value['lastUpdateDatetime'] == null ? value['lastUpdateDatetime'] : value['lastUpdateDatetime'].toISOString(),
        'data': MstUserOutputToJSON(value['data']),
    };
}

